import {createFileRoute} from '@tanstack/react-router'
import {secondLevelLayoutRoute} from "../../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName')({
    ...secondLevelLayoutRoute()
});
